import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Device } from '../../../models/device';
import { DevicesService } from '../../../services/devices.service';
import { LoginUserModel } from '../../../models/loginUserModel';
import { ReportsServicesService } from '../../../services/reports-services.service';
import { map } from 'rxjs';
import { InputTextModule } from 'primeng/inputtext';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';

type AnyObject = Record<string, any>;
@Component({
    selector: 'app-fuel-params-form',
    imports: [CommonModule, ReactiveFormsModule, FormsModule, InputTextModule, InputGroupModule, InputGroupAddonModule, SelectButtonModule, ButtonModule, DialogModule],
    templateUrl: './fuel-params-form.component.html',
    styleUrl: './fuel-params-form.component.scss',
})
export class FuelParamsFormComponent {
  formCard!: FormGroup;
  data!: LoginUserModel;
  tokenAuth = "";
  @Output() onSaving: EventEmitter<any> = new EventEmitter<any>();
  @Output() onResponse: EventEmitter<any> = new EventEmitter<any>();
  constructor(private service: DevicesService, private reportsSvc: ReportsServicesService) {

    this.data = JSON.parse(localStorage.getItem('data')!);
  }
  showMessageError = false;
  messagesError = "";
  @Input() device!: Device;
  oldDevice!: Device;
  showConfirm = false;
  messageConfirm = '';
  changesList: { field: string; from: string; to: string }[] = [];
  changes: any = null;

  loadTypeOptions = [
    { label: 'Importe', value: false, icon: 'pi pi-dollar' },
    { label: 'Litros', value: true, icon: 'pi pi-box' }
  ];
  ngOnInit() {
    this.oldDevice = structuredClone(this.device);
    const nullIfZero = (v: any) => v > 0 ? v : null;
    this.formCard = new FormGroup({
      selectedType: new FormControl(this.device ? this.device.portalLoadType : false),
      dailyLiters: new FormControl(nullIfZero(this.device?.dailyLimitLiters), [Validators.min(1)]),
      weeklyLiters: new FormControl(nullIfZero(this.device?.weeklyLimitLiters), [Validators.min(1)]),
      monthlyLiters: new FormControl(nullIfZero(this.device?.monthlyLimitLiters), [Validators.min(1)]),
      dailyAmount: new FormControl(nullIfZero(this.device?.dailyLimitAmount), [Validators.min(1)]),
      weeklyAmount: new FormControl(nullIfZero(this.device?.weeklyLimitAmount), [Validators.min(0)]),
      monthlyAmount: new FormControl(nullIfZero(this.device?.monthlyLimitAmount), [Validators.min(1)]),
      maxLoads: new FormControl(this.device ? this.device.maxDailyLoads : 1, [Validators.required, Validators.min(1), Validators.max(99)]),
    });
    // Al cambiar modo, limpiar errores
    this.loadType.valueChanges.subscribe(() => {
      this.showMessageError = false;
      this.messagesError = '';
    });
  }


  get maxLoads() {
    return this.formCard.get('maxLoads') as FormControl;
  }
  get loadType() {
    return this.formCard.get('selectedType') as FormControl;
  }

  get dailyLiters() {
    return this.formCard.get('dailyLiters') as FormControl;
  }
  get weeklyLiters() {
    return this.formCard.get('weeklyLiters') as FormControl;
  }
  get monthlyLiters() {
    return this.formCard.get('monthlyLiters') as FormControl;
  }
  get dailyAmount() {
    return this.formCard.get('dailyAmount') as FormControl;
  }

  get weeklyAmount() {
    return this.formCard.get('weeklyAmount') as FormControl;
  }
  get monthlyAmount() {
    return this.formCard.get('monthlyAmount') as FormControl;
  }




  selectTipo(type: string) {
    if (this.data.UserType == 'Administrator' || this.data.UserType == 'Modify') {
      this.loadType.setValue(type != 'importe')
      this.showMessageError = false;
      this.messagesError = "";
    }
  }

  /** Indica si un campo fue modificado respecto al valor original */
  isModified(field: string): boolean {
    const map: Record<string, keyof Device> = {
      dailyLiters: 'dailyLimitLiters', weeklyLiters: 'weeklyLimitLiters', monthlyLiters: 'monthlyLimitLiters',
      dailyAmount: 'dailyLimitAmount', weeklyAmount: 'weeklyLimitAmount', monthlyAmount: 'monthlyLimitAmount',
      maxLoads: 'maxDailyLoads'
    };
    const ctrl = this.formCard.get(field);
    return ctrl != null && ctrl.value != (this.oldDevice as any)[map[field]];
  }


  validateAmounts() {
    if (this.loadType.value) {
      return (this.dailyLiters.value > 0 || this.weeklyLiters.value > 0 || this.monthlyLiters.value > 0);
    } else {
      return (this.dailyAmount.value > 0 || this.weeklyAmount.value > 0 || this.monthlyAmount.value > 0);
    }
  }


  greaterThanAndPositive = (a: any, b: any) => {
    const na = Number(a ?? 0);
    const nb = Number(b ?? 0);
    return !isNaN(na) && !isNaN(nb) && na > nb && nb > 0;
  };

  // Helper que setea mensaje y flag
  setError = (msg: string) => {
    this.showMessageError = true;
    this.messagesError = msg;
    return ; // para poder returnar desde el llamador
  };

  showModalConfirmChanges() {
    this.showMessageError = false;
    this.messagesError = "";


    if (this.loadType.value) {
      const daily = this.dailyLiters?.value;
      const weekly = this.weeklyLiters?.value;
      const monthly = this.monthlyLiters?.value;

      if (this.greaterThanAndPositive(daily, weekly)) {
         this.setError('Los litros diarios no puede ser mayor al semanal');
         return;
      }
      if (this.greaterThanAndPositive(daily, monthly)) {
         this.setError('Los litros diarios no puede ser mayor al mensual');
         return;
      }
      if (this.greaterThanAndPositive(weekly, monthly)) {
         this.setError('Los litros semanales no puede ser mayor a los mensuales');
         return;
      }
    } else {
      const daily = this.dailyAmount?.value;
      const weekly = this.weeklyAmount?.value;
      const monthly = this.monthlyAmount?.value;

      if (this.greaterThanAndPositive(daily, weekly)) {
         this.setError('El importe diario no puede ser mayor al semanal');
         return;
      }
      if (this.greaterThanAndPositive(daily, monthly)) {
         this.setError('El importe diario no puede ser mayor al mensual');
         return;
      }
      if (this.greaterThanAndPositive(weekly, monthly)) {
         this.setError('El importe semanal no puede ser mayor al mensual');
         return;
      }
    }
   

    if (this.loadType.value) {
      this.device.dailyLimitLiters = this.dailyLiters.value;
      if (this.dailyLiters.value > 0) {
        this.device.checkDaylyLiters = true;
        this.device.dailyLimitAmount = 0;
        this.device.checkDaylyAmount = false
      } else {
        this.device.dailyLimitLiters = 0;
      }

      this.device.weeklyLimitLiters = this.weeklyLiters.value;
      if (this.weeklyLiters.value > 0) {
        this.device.checkWeeklyLiters = true;
        this.device.weeklyLimitAmount = 0;
        this.device.checkWeeklyAmount = false
      } else {
        this.device.weeklyLimitLiters = 0;
      }

      this.device.monthlyLimitLiters = this.monthlyLiters.value;
      if (this.monthlyLiters.value > 0) {
        this.device.checkMonthlyLiters = true;
        this.device.monthlyLimitAmount = 0;
        this.device.checkMonthlyAmount = false
      } else {
        this.device.monthlyLimitLiters = 0;
      }

      this.device.checkDaylyAmount = false;
      this.device.dailyLimitAmount = 0;
      this.device.checkWeeklyAmount = false;
      this.device.weeklyLimitAmount = 0
      this.device.checkMonthlyAmount = false;
      this.device.monthlyLimitAmount = 0;


    } else {

      this.device.dailyLimitAmount = this.dailyAmount.value;
      if (this.dailyAmount.value > 0) {
        this.device.checkDaylyAmount = true;
        this.device.dailyLimitLiters = 0;
        this.device.checkDaylyLiters = false
      } else {
        this.device.dailyLimitAmount = 0;
      }

      this.device.weeklyLimitAmount = this.weeklyAmount.value;
      if (this.weeklyAmount.value > 0) {
        this.device.checkWeeklyAmount = true;
        this.device.weeklyLimitLiters = 0
        this.device.checkWeeklyLiters = false

      } else {
        this.device.weeklyLimitAmount = 0;

      }

      this.device.monthlyLimitAmount = this.monthlyAmount.value;
      if (this.monthlyAmount.value > 0) {
        this.device.checkMonthlyAmount = true;
        this.device.monthlyLimitLiters = 0;
        this.device.checkMonthlyLiters = false
      } else {
        this.device.monthlyLimitAmount = 0;
      }

      this.device.checkDaylyLiters = false;
      this.device.dailyLimitLiters = 0;
      this.device.checkWeeklyLiters = false;
      this.device.weeklyLimitLiters = 0
      this.device.checkMonthlyLiters = false;
      this.device.monthlyLimitLiters = 0;
    }
    this.device.maxDailyLoads = this.formCard.get('maxLoads')!.value;
    this.device.portalLoadType = this.loadType.value;

    const fieldLabels: Record<string, string> = {
      dailyLimitAmount: 'Importe diario', weeklyLimitAmount: 'Importe semanal', monthlyLimitAmount: 'Importe mensual',
      dailyLimitLiters: 'Litros diarios', weeklyLimitLiters: 'Litros semanales', monthlyLimitLiters: 'Litros mensuales',
      maxDailyLoads: 'Cargas máximas diarias', portalLoadType: 'Tipo de carga'
    };
    const formatVal = (key: string, v: any) => {
      if (key === 'portalLoadType') return v ? 'Litros' : 'Importe';
      return v ?? 0;
    };
    const fields = Object.keys(fieldLabels);
    this.changesList = [];
    for (const f of fields) {
      const oldVal = (this.oldDevice as any)[f];
      const newVal = (this.device as any)[f];
      if (JSON.stringify(oldVal) !== JSON.stringify(newVal)) {
        this.changesList.push({ field: fieldLabels[f], from: formatVal(f, oldVal), to: formatVal(f, newVal) });
      }
    }
    // Mantener changes para el check de "No hay cambios"
    this.changes = this.changesList.length > 0 ? 'changed' : '';
    if (this.changesList.length > 0) {
      this.showConfirm = true;
    }

  }

  saveCardParams() {

    this.showMessageError = false;
    this.messagesError = "";
    if (this.validateAmounts()) {
      if (this.maxLoads.valid) {
        this.onSaving.emit(true);
        this.service.saveCardParams(this.device, this.data.Client_number, this.data.User_id, "Parametros", this.data.UserType == 'Administrator' ? 'Administrador de la cuenta' : this.data.Name).subscribe({
          next: (resp: any) => {
            this.onSaving.emit(false);
            resp.isSave = true;
            if (resp.errorCode == 1) {
              this.showMessageError = true;
              this.messagesError = resp.errorDesc;

            } else {

              const n = (v: number) => v > 0 ? v : null;
              this.dailyAmount.setValue(n(this.device.dailyLimitAmount));
              this.weeklyAmount.setValue(n(this.device.weeklyLimitAmount));
              this.monthlyAmount.setValue(n(this.device.monthlyLimitAmount));
              this.dailyLiters.setValue(n(this.device.dailyLimitLiters));
              this.weeklyLiters.setValue(n(this.device.weeklyLimitLiters));
              this.monthlyLiters.setValue(n(this.device.monthlyLimitLiters));
              this.oldDevice = structuredClone(this.device);
              this.onResponse.emit(resp);
            }
          },
          error: (error: any) => {
            this.showMessageError = true;
            this.messagesError = "Error al guardar los parámetros.";
          }
        })
      }

    } else {
      this.showMessageError = true;
      this.messagesError = "Es requerido ingresar un límite (diario, semanal o mensual) en " + (this.loadType.value ? "litros." : "m.n.");
    }
  }

  onChange(input: string, event: any) {
    if (parseFloat(event.target.value) > 0.00) {
      switch (input) {
        case "daily":
          if (this.loadType.value) {
            this.formCard.get('dailyAmount')!.setValue(0);
          } else {
            this.formCard.get('dailyLiters')!.setValue(0);
          }
          break;

        case "weekly":
          if (this.loadType.value) {
            this.formCard.get('weeklyAmount')!.setValue(0);
          } else {
            this.formCard.get('weeklyLiters')!.setValue(0);
          }
          break;

        case "monthly":
          if (this.loadType.value) {
            this.formCard.get('monthlyAmount')!.setValue(0);
          } else {
            this.formCard.get('monthlyLiters')!.setValue(0);
          }
          break;
        default:
          break;
      }
    }
  }

  async showHistorial() {
    let historicConsumptions: any;
    let weeklyConsumptions: any[] = [];
    let monthyConsumptions: any[] = [];
    this.onSaving.emit(true);

    let dailyData = await this.getDailyConsumptions();


    let weeklyData = await this.getWeeklyConsumptions();

    let monthlyData = await this.getMonthlyConsumptions();


    historicConsumptions = {
      daily: dailyData,
      weekly: weeklyData,
      monthly: monthlyData,
    }
    this.onSaving.emit(false);
    this.onResponse.emit({
      isSave: false,
      data: historicConsumptions
    })


  }


  getDailyConsumptions(): Promise<any> {
    let data: any;
    let fromDateRequest = new Date();
    let toDateRequest = new Date(fromDateRequest.getFullYear(), fromDateRequest.getMonth(), fromDateRequest.getDate() + 1);
    return this.reportsSvc.getConsumptions(this.data.Client_id, fromDateRequest, toDateRequest, this.device.number, this.device.number, 1, 30, -1, 0, 0).pipe(
      map((resp: any) => {
        let quantity = 0;
        let totalAmount = 0;
        resp.forEach((c: any) => {
          quantity += c.quantity;
          totalAmount += c.amount;
        });
        return {
          amount: totalAmount,
          quantity: quantity,
          loads: resp.length
        };
      })

    ).toPromise();
  }

  async getWeeklyConsumptions() {

    let today = new Date();
    let currentWeekStart = new Date(today.getFullYear(), today.getMonth(), (today.getDate()));
    console.log(currentWeekStart);
    let nextWeek = new Date(currentWeekStart.getFullYear(), currentWeekStart.getMonth(), (currentWeekStart.getDate() + 7));

    let fromDateRequest = this.startOfWeek(currentWeekStart, 0);
    let toDateRequest = this.startOfWeek(nextWeek, 6);
    return this.reportsSvc.getConsumptions(this.data.Client_id, fromDateRequest, toDateRequest, this.device.number, this.device.number, 1, 30, -1, 0, 0).pipe(
      map((resp: any) => {
        let quantity = 0;
        let totalAmount = 0;
        resp.forEach((c: any) => {
          quantity += c.quantity;
          totalAmount += c.amount;

        });
        return {
          amount: totalAmount,
          quantity: quantity,
          loads: resp.length
        };
      })

    ).toPromise();

  }

  async getMonthlyConsumptions() {

    let today = new Date();

    let currentMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    let nextMonth = new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 0);
    let fromDateRequest = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), 1);
    let toDateRequest = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
    return this.reportsSvc.getConsumptions(this.data.Client_id, fromDateRequest, toDateRequest, this.device.number, this.device.number, 1, 30, -1, 0, 0).pipe(
      map((resp: any) => {
        let quantity = 0;
        let totalAmount = 0;
        resp.forEach((c: any) => {
          quantity += c.quantity;
          totalAmount += c.amount;
        });
        return {
          amount: totalAmount,
          quantity: quantity,
          loads: resp.length
        };
      })

    ).toPromise();

  }

  startOfWeek(dateObject: Date, day: number) {
    const year = dateObject.getFullYear();
    const month = dateObject.getMonth();
    const date = dateObject.getDate();
    let diff = (7 + (dateObject.getDay() - day)) % 7;

    return new Date(year, month, date + (-1 * diff));

  }



}

export function getObjectDiff(obj1: AnyObject,
  obj2: AnyObject,
  fields: string[],
  arrayKey: string = 'id' // key used to compare objects inside arrays
): string {
  let result = '';

  const getValue = (obj: AnyObject, path: string) => {
    return path.split('.').reduce((acc, key) => acc?.[key], obj);
  };

  for (const field of fields) {
    const val1 = getValue(obj1, field);
    const val2 = getValue(obj2, field);

    if (JSON.stringify(val1) === JSON.stringify(val2)) continue;

    // --- Handle arrays of objects ---
    if (Array.isArray(val1) && Array.isArray(val2)) {
      const ids1 = new Set(val1.map((v) => v[arrayKey]));
      const ids2 = new Set(val2.map((v) => v[arrayKey]));

      // Added
      for (const item of val2) {
        if (!ids1.has(item[arrayKey])) {
          result += `Campo nuevo a ${field}: ${JSON.stringify(item)}\n`;
        }
      }

      // Removed
      for (const item of val1) {
        if (!ids2.has(item[arrayKey])) {
          result += `Campo removido from ${field}: ${JSON.stringify(item)}\n`;
        }
      }

      // Changed
      for (const item2 of val2) {
        const match = val1.find((v) => v[arrayKey] === item2[arrayKey]);
        if (match && JSON.stringify(match) !== JSON.stringify(item2)) {
          result += `Cambio en  ${field}: ${arrayKey}=${item2[arrayKey]} de ${JSON.stringify(
            match
          )} a ${JSON.stringify(item2)}<br>`;
        }
      }

      continue;
    }

    // --- Simple field compare ---
    if (val1 === undefined && val2 !== undefined) {
      result += `Campo nuevo: ${field} = ${JSON.stringify(val2)}<br>`;
    } else if (val2 === undefined && val1 !== undefined) {
      result += `Campo removido: ${field} (was ${JSON.stringify(val1)})<br>`;
    } else {
      result += `Cambio en: ${field} de ${JSON.stringify(val1)} a ${JSON.stringify(val2)}<br>`;
    }
  }

  return result.trim();
}